const UrlConsts = {
    viewMode: 'setting/set-view-mode',
    approveRejectResetPassword: 'authen/approve-reject-reset-password',
    greyDefault: 'setting/grey-default',
    setNotUsingPassword: 'setting/set-using-password',
    checkAuthenType: 'authen/check-authen-type',
    changePassword: 'authen/change-password',
    changePasswordNo: 'authen/change-password-no',
    createPassword: 'authen/create-password',
    isSignUp: 'authen/is-sign-up',
    login: 'authen/sign-in',
    createUpdateRequired: 'mandatory/create-update',
    verifyToken: 'authen/verify-expires-token',
    scForm: 'g/authen/sc-form',
};

export default UrlConsts;